import axios from "axios";
import qs from "qs";

// 封装为 ApiClient 类
class ApiClient {
  constructor(env = 'dev') {
    this.baseURL = "//test.v2.webevent.61.com/?r=Questionnaire/";
    this.loginURL = "//test.v2.webevent.61.com/?r=login/";
    if (env === 'pre') {
      this.baseURL = "//webevent-test.61.com/v2/?r=Questionnaire/";
      this.loginURL = "//webevent-test.61.com/v2/?r=login/";
    } else if (env === 'prod') {
      this.baseURL = "//webevent.61.com/v2/?r=Questionnaire/";
      this.loginURL = "//webevent.61.com/v2/?r=login/";
    } else if (env === 'local') {
      this.baseURL = "/api";
      this.loginURL = "/login-api";
    }

    this.instance = axios.create({
      baseURL: this.baseURL,
      timeout: 5000,
      withCredentials: true,
      transformRequest: [data => {
        if (data instanceof FormData) {
          return data;
        }
        return qs.stringify(data);
      }],
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });

    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        if (config.url.includes("loginDc")) {
          config.baseURL = this.loginURL;
        } else {
          config.baseURL = this.baseURL;
        }
        return config;
      },
      (err) => Promise.reject(err)
    );

    // 响应拦截器
    this.instance.interceptors.response.use(
      (res) => {
        if (res.data.result === 0) {
          return res.data.data;
        }
        return Promise.reject(res.data.err_desc)
      },
      (error) => Promise.reject(error)
    );
  }

  get(url, params = {}) {
    return this.instance.get(url, { params });
  }

  post(url, params = {}) {
    return this.instance.post(url, params);
  }
}

export default ApiClient;
